<div class="loading-container" [style.height]="height">
  <ion-spinner name="crescent"></ion-spinner>
  <div class="body-sm-medium"> {{ loadingText }} </div>
</div>